var AvailableCountHandler = /** @class */ (function () {
    function AvailableCountHandler(bookersCount) {
        this.bookersCount = bookersCount;
    }
    AvailableCountHandler.prototype.getStatus = function (from, to, quantity) {
        if (quantity < this.bookersCount) {
            return {
                isAvailable: false,
                data: {},
                debug: {
                    to: to,
                    from: from,
                    quantity: quantity,
                    bookersCount: this.bookersCount
                },
                name: this.constructor.name,
            };
        }
        return {
            isAvailable: true,
            data: {},
            name: this.constructor.name,
            from: from,
            to: to,
        };
    };
    return AvailableCountHandler;
}());
export { AvailableCountHandler };
